import { alibabaCloudUpload } from '@/api/common'
import OSS from 'ali-oss'

function fileType(file) {
  if (file.type.includes('image')) {
    return 0 // 图片
  } else if (file.type === 'application/vnd.android.package-archive') {
    return 1 // APK 文件
  } else if (
    file.type === 'application/vnd.ms-excel' ||
    file.type ===
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
    file.type === 'text/csv' ||
    file.type === 'application/x-rar-compressed' ||
    file.type === 'application/zip' ||
    file.type === 'application/msword' ||
    file.type ===
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
    file.type === 'application/pdf' ||
    file.name.endsWith('.rar') ||
    file.name.endsWith('.zip') ||
    file.name.endsWith('.doc') ||
    file.name.endsWith('.docx') ||
    file.name.endsWith('.xls') ||
    file.name.endsWith('.xlsx') ||
    file.name.endsWith('.csv') ||
    file.name.endsWith('.pdf')
  ) {
    return 2 // Excel 文件或 CSV 文件
  } else if (file.type.includes('video')) {
    return 3 // 视频
  }
}

// 获取文件新类型
function fileNewType(file) {
    if (file.type.includes('image')) {
    return 'IMAGE' // 图片
  } else if (file.type === 'application/vnd.android.package-archive') {
    return 'APP' // APK 文件
  } else if (file.type.includes('video')) {
    return 'VIDEO' // 视频
  } else {
    return 'OTHER'
  }
}

/**
 * 判断临时凭证是否到期。
 **/
function isCredentialsExpired(credentials) {
  if (!credentials) {
    return true
  }
  const expireDate = new Date(credentials.Expiration)
  const now = new Date()
  // 如果有效期不足一分钟，视为过期。
  return expireDate.getTime() - now.getTime() <= 60000
}

export async function uploadUtil(file) {
  if (file.type.startsWith('image/')) {
    file = await compressImageIfNeeded(file)
  }
  
  if (file instanceof Blob && !(file instanceof File)) {
    // 你可以根据需要设置文件名和类型
    file = new File([file], `${ Date.now() }-cropped-image.jpg`, {
      type: file.type
    })
  }
  let credentials = null
  // 临时凭证过期时，才重新获取，减少对STS服务的调用。
  let type = fileType(file)
  let newType = fileNewType(file)
  const randomNum = Math.floor(Math.random() * 10000) // 生成0-9999的随机数
  const fileName = randomNum + '-' + Date.now() + '-' + file.name
  if (isCredentialsExpired(credentials)) {
    let data = {
      upload_file_type_enum: newType,
      file_name: fileName
    }
    const { result } = await alibabaCloudUpload(data)
    if (result) {
      const { bucket_name, endpoint, download_base_url, access_key_id, access_key_secret, security_token } = result.data
      let client = new OSS({
        // 将<YOUR_BUCKET>设置为OSS Bucket名称。
        bucket: bucket_name,
        // 将<YOUR_REGION>设置为OSS Bucket所在地域，例如region: 'oss-cn-hangzhou'。
        endpoint: endpoint,
        // region: 'oss-cn-beijing',
        accessKeyId: access_key_id,
        accessKeySecret: access_key_secret,
        stsToken: security_token
      })
      const { res } = await client.put(fileName, file)
      if (res.status === 200) {
        return download_base_url + '/' + encodeURIComponent(fileName)
      }
      return ''
    }
  }
}


const MAX_IMAGE_SIZE = 1024 * 1024 // 1MB
const MAX_EDGE = 1920 // 最大边，防止超大分辨率

// 图片压缩
async function compressImageIfNeeded(file) {
  // 非图片直接返回
  if (!file.type.startsWith('image/')) {
    return file
  }

  // 已经 <= 1MB，直接返回
  if (file.size <= MAX_IMAGE_SIZE) {
    return file
  }

  const img = new Image()
  img.src = URL.createObjectURL(file)

  await new Promise(resolve => (img.onload = resolve))

  let { width, height } = img

  // 1️⃣ 等比缩放分辨率
  if (width > MAX_EDGE || height > MAX_EDGE) {
    const ratio = Math.min(MAX_EDGE / width, MAX_EDGE / height)
    width = Math.round(width * ratio)
    height = Math.round(height * ratio)
  }

  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  const ctx = canvas.getContext('2d')
  // PNG图片先填充白色背景，避免透明区域在JPEG格式下变黑
  const isPng = file.type === 'image/png'
  if (!isPng) {
    ctx.fillStyle = '#fff'
    ctx.fillRect(0, 0, width, height)
  }
  ctx.drawImage(img, 0, 0, width, height)

  // 2️⃣ 动态质量压缩
  // PNG图片保持PNG格式（保留透明通道），JPEG图片保持JPEG格式
  const outputType = isPng ? 'image/png' : 'image/jpeg'
  const outputExt = isPng ? '.png' : '.jpg'
  let quality = isPng ? undefined : 0.9
  let blob

  do {
    blob = await new Promise(resolve =>
      canvas.toBlob(resolve, outputType, quality)
    )
    if (isPng || blob.size <= MAX_IMAGE_SIZE) break
    quality -= 0.1
  } while (quality >= 0.2)

  return new File(
    [blob],
    file?.name?.replace(/\.\w+$/, outputExt) || `cropping${outputExt}`,
    { type: outputType }
  )
}